export default __webpack_public_path__ + "static/media/workouttracker.b6652f0c.png";